// extracted by mini-css-extract-plugin
module.exports = {"result":"style_result__pHaDH"};